import styled from "styled-components";

export const ContactBannerContainer = styled.div`
  width: 100%;
  height: 450px;
  background: #1D1D1D;
  position: relative;
  overflow: hidden;
  
  @media (min-width: 1025px) {
    height: 450px;
  }

  @media (max-width: 768px) {
    height: 596px;
  }
`;

export const ContactBannerContent = styled.div`
  width: 100%;
  height: 100%;
  margin: 0;
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding: 97px 240px 103px;
  box-sizing: border-box;
  
  @media (max-width: 1920px) {
    padding-left: 240px;
    padding-right: 240px;
  }
  
  @media (max-width: 1700px) {
    padding-left: 160px;
    padding-right: 160px;
  }
  
  @media (max-width: 1440px) {
    padding-left: 80px;
    padding-right: 80px;
  }
  
  @media (max-width: 768px) {
    padding: 60px 20px;
    justify-content: space-between;
  }
`;

export const HeadingText = styled.h2`
  color: white;
  font-size: 24px;
  font-family: 'Montserrat', sans-serif;
  font-weight: 700;
  line-height: 36px;
  letter-spacing: -0.04em;
  margin: 0;
  margin-bottom: 40px;
  
  @media (min-width: 1025px) {
    font-size: 48px;
    line-height: 70px;
    letter-spacing: -0.01em;
    margin-bottom: 49px;
  }

  @media (max-width: 768px) {
    margin-bottom: 0;
  }
`;

export const BannerImage = styled.img`
  width: 100%;
  max-width: 300px;
  margin: 20px 0;
  display: none;
  
  @media (max-width: 768px) {
    display: block;
    margin: 35px 0 43px 0;
    max-width: none;
    width: 375px;
    height: 205px;
    object-fit: contain;
    margin-left: 50%;
    transform: translateX(-50%);
  }
`;

export const ButtonContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 0;
  
  @media (min-width: 1025px) {
    flex-direction: row;
    gap: 14px;
    margin-bottom: 103px;
  }
`;

export const ButtonBase = styled.button`
  font-family: 'Pretendard', sans-serif;
  font-size: 16px;
  line-height: 1.75em;
  letter-spacing: -0.01em;
  padding: 16px 30px;
  border-radius: 50px;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  
  @media (max-width: 768px) {
    width: 100%;
    max-width: 100%;
    height: 52px;
  }
`;

export const PrimaryButton = styled(ButtonBase)`
  background-color: #FF4F00;
  color: #FFFFFF;
  font-weight: 700;
  width: 160px;
  
  &:hover {
    background-color: #FF6B33;
  }
  
  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const SecondaryButton = styled(ButtonBase)`
  background-color: #FFFFFF;
  color: #000000;
  font-weight: 500;
  width: 191px;
  
  &:hover {
    color: #FF4F00;
  }
  
  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const BackgroundGraphic = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  width: 60%;
  height: 110%;
  z-index: 1;
  
  @media (max-width: 768px) {
    display: none;
  }
`;

export const VectorImage = styled.img<{ opacity?: number }>`
  position: absolute;
  top: 0;
  right: 0;
  width: 90%;
  height: 90%;
  object-fit: cover;
  object-position: left center;
  opacity: ${props => props.opacity || 0.2};
`; 